function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 7a4 4 0 100 8 4 4 0 000-8zm-6 4a6 6 0 1112 0 6 6 0 01-12 0z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 2a9 9 0 00-9 9c0 .942.364 2.36 1.03 4.107.653 1.715 1.555 3.642 2.542 5.558C12.545 24.498 14.818 28.219 16 30c1.182-1.781 3.455-5.502 5.428-9.335.987-1.916 1.89-3.843 2.543-5.558C24.636 13.36 25 11.942 25 11a9 9 0 00-9-9zm0-2A11 11 0 005 11c0 1.33.482 3.038 1.16 4.819.69 1.81 1.629 3.81 2.634 5.761 2.01 3.904 4.32 7.688 5.54 9.526a2 2 0 003.333 0c1.219-1.838 3.53-5.622 5.54-9.526 1.004-1.951 1.943-3.95 2.633-5.761C26.518 14.038 27 12.329 27 11A11 11 0 0016 0z",
  fill: "currentColor"
})));